import { observable, action, makeObservable } from "mobx";
import { GlobalStore } from "@roc/feature-app-core";

export class AddAppraisalStore {
  globalStore: GlobalStore;
  loan: any;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    makeObservable(this, {
      loan: observable,
      setLoan: action,
      reset: action,
    });
  }

  setLoan(value) {
    this.loan = value;
  }

  reset() {
    this.loan = undefined;
  }
}
